import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import notify from 'devextreme/ui/notify';
import ValidationEngine from 'devextreme/ui/validation_engine';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ScreenService} from '../../../../../shared/services/general';

@Component({
  selector: 'app-patient-responsible-party-form-dialog',
  templateUrl: './patient-responsible-party-form-dialog.component.html',
  styleUrls: ['./patient-responsible-party-form-dialog.component.scss']
})
export class PatientResponsiblePartyFormDialogComponent implements OnInit, OnDestroy {
  public responsiblePartiesForm: UntypedFormGroup = this.fb.group({
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required]),
    address: new UntypedFormControl('', [Validators.required]),
    country: new UntypedFormControl(),
    state: new UntypedFormControl(),
    city: new UntypedFormControl(),
    zipCode: new UntypedFormControl(),
    zipCodeExtra: new UntypedFormControl('',  [Validators.required]),
    phone: new UntypedFormControl('', [Validators.required]),
    mobile: new UntypedFormControl(),
    fax: new UntypedFormControl()
  });
  @Input() public popupVisible: boolean = false;
  @Input() public id = -1;
  @Output() public closed = new EventEmitter();
  public phoneMaskRule = {X: /[0-9]/};
  public isPhoneOrTablet: boolean = false;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private fb: UntypedFormBuilder, private screen: ScreenService) {
  }

  public ngOnInit(): void {
    this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    this.screen.changed.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.isPhoneOrTablet = this.screen.sizes['screen-x-small'] || this.screen.sizes['screen-small'] || this.screen.sizes['screen-tablet'];
    });
  }

  public convertToFormControl(absCtrl: AbstractControl | null): UntypedFormControl {
    return absCtrl as UntypedFormControl;
  }

  public clear() {
    this.responsiblePartiesForm.get('firstName')?.setValue('');
    this.responsiblePartiesForm.get('lastName')?.setValue('');
    this.responsiblePartiesForm.get('address')?.setValue('');
    this.responsiblePartiesForm.get('country')?.setValue(null);
    this.responsiblePartiesForm.get('state')?.setValue(null);
    this.responsiblePartiesForm.get('city')?.setValue(null);
    this.responsiblePartiesForm.get('zipCode')?.setValue('');
    this.responsiblePartiesForm.get('zipCodeExtra')?.setValue('');
    this.responsiblePartiesForm.get('phone')?.setValue('');
    this.responsiblePartiesForm.get('mobile')?.setValue('');
    this.responsiblePartiesForm.get('fax')?.setValue('');
  }

  public close() {
    this.popupVisible = false;
    this.responsiblePartiesForm.reset();
    this.closed.emit();
    ValidationEngine.resetGroup('responsibleParty');
    ValidationEngine.resetGroup('address');
  }


  public save() {
    const responsibleParty = ValidationEngine.validateGroup('responsibleParty');
    const address = ValidationEngine.validateGroup('address');
    if (responsibleParty.isValid && address.isValid) {
      if (this.responsiblePartiesForm.get('zipCode')?.value) {
        const rp = this.responsiblePartiesForm.value;
        rp.firstName = rp.firstName.toUpperCase();
        rp.lastName = rp.lastName.toUpperCase();
        this.popupVisible = false;
        this.closed.emit(rp);
        this.clear();
        ValidationEngine.resetGroup('responsibleParty');
        ValidationEngine.resetGroup('address');
      } else {
        notify('Missing address information', 'error');
      }
    }
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
